import { MappedEntity } from '@api';
import { PriceStatus } from '@helpers';
import { globalPriceFormatter } from '@terminal/utils/asset-price/assetPrice';

import styles from './CatalystSingleMarketReactionPrice.module.scss';

export const priceStatusClassMap: Record<PriceStatus, string> = {
  [PriceStatus.Default]: styles.default,
  [PriceStatus.Negative]: styles.negative,
  [PriceStatus.Positive]: styles.positive,
};

export const formatPrice = (price: number, entity: MappedEntity) =>
  globalPriceFormatter({
    entity,
    price,
    priceSuffix: '',
    shouldShowCurrency: false,
  });
